import { RouteSwitch } from "components/RouteSwitch";
import { Route, useRouteMatch } from "react-router-dom";
import { CreateTeam } from "../domain/create";
import { EditTeam } from "../domain/edit";
import { Invitations } from "../domain/invitations";

export const Container = () => {
  const match = useRouteMatch();

  return (
    <RouteSwitch>
      <Route exact path={match.path + "/create"}>
        <CreateTeam />
      </Route>
      <Route exact path={match.path + "/edit"}>
        <EditTeam />
      </Route>
      <Route exact path={match.path + "/invitations"}>
        <Invitations />
      </Route>
    </RouteSwitch>
  );
};
